"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var free_gifts_service_1 = require("../../services/free-gifts.service");
var FreeGifts = /** @class */ (function () {
    function FreeGifts(cart) {
        this.selectors = {
            body: 'body',
            freeGiftCheckbox: '.js-free-gift-checkbox',
            freeGiftsPopupCloseBtn: '.cart-free-gifts__close',
            cartFreeGiftsPopup: '.js-cart-free-gifts',
            freeGiftsPopupContent: '.cart-free-gifts__products .cart-free-gifts__products-inner',
            addFreeGiftBtn: '.js-add-free-gift-btn',
            spendMoreContainer: '.js-spend-more-container',
            openFreeGiftPopupLink: '.js-open-free-gift-popup',
        };
        this.cart = cart;
        this.freeGiftsService = new free_gifts_service_1["default"](this.cart);
        this.init();
    }
    FreeGifts.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.bindEvents();
                return [2 /*return*/];
            });
        });
    };
    ;
    FreeGifts.prototype.bindEvents = function () {
        var _this = this;
        var me = this;
        var $body = $(this.selectors.body);
        $body.on('change', this.selectors.freeGiftCheckbox, function (e) {
            _this.handleFreeGiftCheckboxChange(e.target);
        });
        $body.on('click', this.selectors.freeGiftsPopupCloseBtn, function (e) {
            _this.hidePopup();
        });
        $body.on('click', this.selectors.cartFreeGiftsPopup, function (e) {
            if (e.target === this) {
                me.hidePopup();
            }
        });
        $body.on('click', this.selectors.openFreeGiftPopupLink, function (e) {
            e.preventDefault();
            me.showPopup();
        });
    };
    FreeGifts.prototype.appendPopup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var html, isCartQualify;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.freeGiftsService.getPopupItemsHtml()];
                    case 1:
                        html = _a.sent();
                        if (!html) return [3 /*break*/, 3];
                        $(this.selectors.freeGiftsPopupContent).html(html);
                        this.preSelectFreeGifts();
                        return [4 /*yield*/, this.freeGiftsService.isCartQualify()];
                    case 2:
                        isCartQualify = _a.sent();
                        if (isCartQualify) {
                            this.showPopup();
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FreeGifts.prototype.showPopup = function () {
        $(this.selectors.cartFreeGiftsPopup).addClass('is-active');
    };
    FreeGifts.prototype.hidePopup = function () {
        $(this.selectors.cartFreeGiftsPopup).removeClass('is-active');
    };
    FreeGifts.prototype.handleFreeGiftCheckboxChange = function (target) {
        var currentThreshold = this.freeGiftsService.currentThreshold;
        if (!currentThreshold) {
            return;
        }
        var $checkbox = $(target);
        //if is GWP
        if ($checkbox.data('is-gwp') === true) {
            this.disableAddToCartButtons('GWP', false);
            this.disableAddToCartButtons('Sample', true);
            return this.checkObjAndUncheckRestFreeGifts($checkbox);
        }
        else {
            this.disableAddToCartButtons('GWP', true);
            this.disableAddToCartButtons('Sample', false);
        }
        var $selectedFreeGifts = $(this.selectors.freeGiftCheckbox + ':checked');
        var selectedFreeGiftsNumber = $selectedFreeGifts.length;
        if (selectedFreeGiftsNumber > 1 && currentThreshold.numberOfFreeGifts === 1) {
            return this.checkObjAndUncheckRestFreeGifts($checkbox);
        }
        var $gwpCheckbox = $(this.selectors.freeGiftCheckbox + '[data-is-gwp="true"]');
        $gwpCheckbox.prop('checked', false);
        if (selectedFreeGiftsNumber > currentThreshold.numberOfFreeGifts) {
            if ($checkbox.attr('id') !== $selectedFreeGifts.eq(0).attr('id')) {
                $selectedFreeGifts.eq(0).prop('checked', false);
            }
            else {
                $selectedFreeGifts.eq(1).prop('checked', false);
            }
        }
    };
    FreeGifts.prototype.disableAddToCartButtons = function (type, status) {
        $(this.selectors.addFreeGiftBtn + "[data-product-type=\"" + type + "\"]").prop('disabled', status);
    };
    FreeGifts.prototype.checkObjAndUncheckRestFreeGifts = function ($checkbox) {
        $(this.selectors.freeGiftCheckbox).prop('checked', false);
        $checkbox.prop('checked', true);
    };
    FreeGifts.prototype.preSelectFreeGifts = function () {
        var isFreeGiftSelected = false;
        for (var _i = 0, _a = this.cart.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.product_type.toLowerCase() === 'sample' || item.product_type.toLowerCase() === 'gwp') {
                var $freeGiftCheckbox = $("#free-gift-checkbox-" + item.id);
                if ($freeGiftCheckbox.length) {
                    $freeGiftCheckbox.prop('checked', true);
                    isFreeGiftSelected = true;
                }
            }
        }
        if (!isFreeGiftSelected) {
            $('[data-is-gwp="true"]').prop('checked', true);
        }
        else {
            $(this.selectors.addFreeGiftBtn).prop('disabled', false);
        }
    };
    FreeGifts.prototype.appendSpendMoreElement = function () {
        return __awaiter(this, void 0, void 0, function () {
            var html, spendMoreContainer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.freeGiftsService.getSpendMoreHtml()];
                    case 1:
                        html = _a.sent();
                        spendMoreContainer = $(this.selectors.spendMoreContainer);
                        spendMoreContainer.html(html);
                        spendMoreContainer.show();
                        return [2 /*return*/];
                }
            });
        });
    };
    return FreeGifts;
}());
exports["default"] = FreeGifts;
